export const TAB_BAR = Symbol('TAB_BAR');
